import Text from "../../atoms/Text";

const render = ({ userRedemptionId, userRewardId }) => {
  return (
    <Text direction="row" spacing={1} alignItems={"center"}>
      {userRedemptionId || userRewardId}
    </Text>
  );
};

const IdCell = params => {
  return render(params.value);
};

export default IdCell;
